import { WindowState } from 'shared/types'

export const applyWindowSizeToAllWindows = (
  windows: WindowState[],
  size: { width: number; height: number }
) => {
  if (windows.length === 0) {
    return windows
  }

  let hasChanges = false

  const nextWindows = windows.map(window => {
    if (
      window.size.width === size.width &&
      window.size.height === size.height
    ) {
      return window
    }

    hasChanges = true

    return {
      ...window,
      size
    }
  })

  return hasChanges ? nextWindows : windows
}
